export default __webpack_public_path__ + "static/media/logo-without-text.56d15905.svg";